const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL || "http://localhost:3000/api";

export async function fetchHomepageData() {
  try {
    // 1. Make the request and wait for headers (fastest part)
    const response = await fetch(`${API_BASE_URL}/homepage`);
    console.log("Response status:", response.status); // Log the status code for debugging

    // 2. CRITICAL CHECK: Handle HTTP Status Codes (404, 500, etc.)
    if (!response.ok) {
      // If the status is bad (e.g., 404 or 500), throw an error
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    // 3. Parse the JSON body (this waits for headers AND body)
    return await response.json();
  } catch (error) {
    // Catch network errors (DNS failure, server down) OR the error thrown above.
    console.error("Failed to fetch homepage data:");
    // Depending on your app, you might return null, an empty object, or re-throw
    return [];
  }
}

export async function fetchProductCategoryData() {
  try {
    // 1. Make the request and wait for headers (fastest part)
    const response = await fetch(`${API_BASE_URL}/categories`);

    // 2. CRITICAL CHECK: Handle HTTP Status Codes (404, 500, etc.)
    if (!response.ok) {
      // If the status is bad (e.g., 404 or 500), throw an error
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    // 3. Parse the JSON body (this waits for headers AND body)
    return await response.json();
  } catch (error) {
    // Catch network errors (DNS failure, server down) OR the error thrown above.
    console.error("Failed to fetch product categories data:");
    // Depending on your app, you might return null, an empty object, or re-throw
    return [];
  }
}

export async function fetchProductsData(categorySlug: string) {
  try {
    const queryParam = categorySlug ? `?category=${categorySlug}` : ""

    // 1. Make the request and wait for headers (fastest part)
    const response = await fetch(`${API_BASE_URL}/products${queryParam}`);
    // 2. CRITICAL CHECK: Handle HTTP Status Codes (404, 500, etc.)
    if (!response.ok) {
      // If the status is bad (e.g., 404 or 500), throw an error
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    // 3. Parse the JSON body (this waits for headers AND body)
    return await response.json();
  } catch (error) {
    // Catch network errors (DNS failure, server down) OR the error thrown above.
    console.error("Failed to fetch products data:");
    // Depending on your app, you might return null, an empty object, or re-throw
    return [];
  }
}

export async function fetchProductData(slug: string) {
  try {
    // 1. Make the request and wait for headers (fastest part)
    const response = await fetch(
      `${API_BASE_URL}/products/${slug}`,
    );

    // 2. CRITICAL CHECK: Handle HTTP Status Codes (404, 500, etc.)
    if (!response.ok) {
      // If the status is bad (e.g., 404 or 500), throw an error
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    // 3. Parse the JSON body (this waits for headers AND body)
    const productData = await response.json();
    // 4. Success! Return the clean data
    return productData;
  } catch (error) {
    // Catch network errors (DNS failure, server down) OR the error thrown above.
    console.error("Failed to fetch product data:");
    // Depending on your app, you might return null, an empty object, or re-throw
    return null;
  }
}

export async function fetchServicesData() {
  try {
    // 1. Make the request and wait for headers (fastest part)
    const response = await fetch(`${API_BASE_URL}/services`);

    // 2. CRITICAL CHECK: Handle HTTP Status Codes (404, 500, etc.)
    if (!response.ok) {
      // If the status is bad (e.g., 404 or 500), throw an error
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    // 3. Parse the JSON body (this waits for headers AND body)
    return await response.json();
  } catch (error) {
    // Catch network errors (DNS failure, server down) OR the error thrown above.
    console.error("Failed to fetch services data:");
    // Depending on your app, you might return null, an empty object, or re-throw
    return [];
  }
}


export async function fetchServiceData(slug: string) {
  try {
    // 1. Make the request and wait for headers (fastest part)
    const response = await fetch(
      `${API_BASE_URL}/services/${slug}`,
    );

    // 2. CRITICAL CHECK: Handle HTTP Status Codes (404, 500, etc.)
    if (!response.ok) {
      // If the status is bad (e.g., 404 or 500), throw an error
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    // 3. Parse the JSON body (this waits for headers AND body)
    const productData = await response.json();
    // 4. Success! Return the clean data
    return productData;
  } catch (error) {
    // Catch network errors (DNS failure, server down) OR the error thrown above.
    console.error("Failed to fetch service data:");
    // Depending on your app, you might return null, an empty object, or re-throw
    return null;
  }
}



export async function fetchSolutionsData(categorySlug: string) {
  try {

    // 1. Make the request and wait for headers (fastest part)
    const response = await fetch(`${API_BASE_URL}/solutions`);
    // 2. CRITICAL CHECK: Handle HTTP Status Codes (404, 500, etc.)
    if (!response.ok) {
      // If the status is bad (e.g., 404 or 500), throw an error
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    // 3. Parse the JSON body (this waits for headers AND body)
    return await response.json();
  } catch (error) {
    // Catch network errors (DNS failure, server down) OR the error thrown above.
    console.error("Failed to fetch solutions data:");
    // Depending on your app, you might return null, an empty object, or re-throw
    return [];
  }
}

export async function fetchSolutionData(slug: string) {
  try {
    // 1. Make the request and wait for headers (fastest part)
    const response = await fetch(
      `${API_BASE_URL}/solutions/${slug}`,
    );

    // 2. CRITICAL CHECK: Handle HTTP Status Codes (404, 500, etc.)
    if (!response.ok) {
      // If the status is bad (e.g., 404 or 500), throw an error
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    // 3. Parse the JSON body (this waits for headers AND body)
    const productData = await response.json();
    // 4. Success! Return the clean data
    return productData;
  } catch (error) {
    // Catch network errors (DNS failure, server down) OR the error thrown above.
    console.error("Failed to fetch solution data:");
    // Depending on your app, you might return null, an empty object, or re-throw
    return null;
  }
}